import { useContext, useState } from 'react';
import { ConfigContext } from '../../../../Contexts/ConfigContext';
import { Paper, Grid } from '@mui/material';
import CheckBoxInput from '../../../../Components/CheckBoxInput';
import useCommonStyles from '../../../../commonStyles';
import PageHeading from '../../../../Components/PageHeading';
import InputConfig from '../../../../Components/InputConfig';

/**
 * @name AggressiveUnmuteOptimization
 * @description This component is an editor for aggressiveUnmuteOptimization configuration.
 *
 * aggressiveUnmuteOptimization: {
 *   "enabled": true
 * }
 *
 * @param {{keyData: 'experimentalFeaturesData.aggressiveUnmuteOptimization'}} keyData - A key used to identify the configuration in the rawConfig object.
 */
const AggressiveUnmuteOptimization = ({ keyData, featureDescription }) => {
	const { rawConfig, updateRawConfig } = useContext(ConfigContext);
	const [isApprovedByProduct, setIsApprovedByProduct] = useState(false);
	const commonStyleClasses = useCommonStyles();
	const isAggressiveUnmuteOptimizationEnabled = !!rawConfig[keyData + '.enabled'];

	return (
		<Paper className={commonStyleClasses.mainPagePaperMarginStyle}>
			<PageHeading
				headingName="Aggressive VpMute (Product Approval Required)"
				headingPath={['Dashboard', 'Framerate', 'Experiments', 'Aggressive VpMute']}
				description="Manage Aggressive Unmute After Interaction Configuration"
				showInfoButton = {true}
				infoMessage={featureDescription}
			/>

			<Grid container spacing={0} style={{ marginTop: '4rem', width: '90%', marginLeft: '5rem' }}>
				<Grid item xs={3}>
					<CheckBoxInput
						directValue={isApprovedByProduct || isAggressiveUnmuteOptimizationEnabled}
						label="Approved by Product"
						isObjectEditor={false}
						object={rawConfig}
						updateDirectValue={setIsApprovedByProduct}
						style={{ width: '28rem' }}
					/>
				</Grid>
				{(isApprovedByProduct || isAggressiveUnmuteOptimizationEnabled) && (
					<>
						<Grid item xs={3}>
							<CheckBoxInput
								keyData={keyData + '.enabled'}
								label="Enabled"
								disabled={false}
								defaultChecked={false}
								object={rawConfig}
								updateObject={updateRawConfig}
								style={{ width: '15rem' }}
							/>
						</Grid>

						<Grid item xs={3} sx={{ marginTop: '-3rem' }}>
							<InputConfig
								editable={isAggressiveUnmuteOptimizationEnabled}
								inputType="number"
								label="Split %"
								keyData={keyData + '.trafficSplit'}
								object={rawConfig}
								updateObject={updateRawConfig}
								inputProps={{ min: 0, max: 100 }}
								onChangeCheck={(val) => val >= 0 && val <= 100}
							/>
						</Grid>
					</>
				)}
			</Grid>
		</Paper>
	);
};

export default AggressiveUnmuteOptimization;
